<template>
  <div>
    <Header/>
    <div class="container">
      <h2 class="text-bold text-orange mt-5">ติดต่อเรา</h2>
      <hr>
      <div class="row">
        <div class="col-lg-6 col-sm-12">
          <div class="d-flex font-contact">
            <div class="col-6">
              <p class="text-bold">เบอร์โทรติดต่อ</p>
              <hr>
              <p>
                <span class="text-10">
                  <i class="fas fa-tty"></i> 00-000-0000
                </span>
                <br>
                <span class="text-gray text-10">
                  <i class="fas fa-clock"></i> (Mon-Fri 09:00-17:00)
                </span>
                <br>
                <span class="text-10">
                  <i class="fas fa-mobile-alt"></i> 000-000-0000, 000-000-0000
                </span>
              </p>
            </div>
            <div class="col-6">
              <p class="text-bold">Social</p>
              <hr>
              <div class="d-flex">
                <div class="p-2" title="โทรหาเราเลย">
                  <a href="Tel:000-000-0000">
                    <i class="fas fa-phone-volume fa-2x text-primary"></i>
                  </a>
                </div>
                <div class="p-2" title="ติดต่อทาง Facebook">
                  <i class="fab fa-facebook fa-2x text-facebook"></i>
                </div>
                <div class="p-2" title="ติดต่อทาง Line">
                  <i class="fab fa-line fa-2x text-line"></i>
                </div>
              </div>
            </div>
          </div>
          <form @submit.prevent="sendMessage()">
            <div class="form-group mt-2">
              <input type="text" v-model="form.name" v-validate="'required'" name="name" class="form-control" :class="{'input': true, 'is-invalid': errors.has('name') }" placeholder="ชื่อ">
              <i v-show="errors.has('name')" class="fas fa-warning"></i>
              <span v-show="errors.has('name')" class="text-danger text-10">{{ errors.first('name') }}</span>
            </div>
            <div class="form-group">
              <input type="text" v-model="form.email" v-validate="'required|email'" name="email" class="form-control" :class="{'input': true, 'is-invalid': errors.has('email') }" placeholder="อีเมล">
              <i v-show="errors.has('email')" class="fas fa-warning"></i>
              <span v-show="errors.has('email')" class="text-danger text-10">{{ errors.first('email') }}</span>
            </div>
            <div class="form-group">
              <input type="text" v-model="form.phone" v-validate="'required|numeric|min:10|max:15'" name="phone" class="form-control" :class="{'input': true, 'is-invalid': errors.has('phone')}" placeholder="เบอร์โทรศัพท์">
              <i v-show="errors.has('phone')" class="fas fa-warning"></i>
              <span v-show="errors.has('phone')" class="text-danger text-10">{{ errors.first('phone') }}</span>
            </div>
            <div class="form-group">
              <textarea rows="8" v-model="form.message" v-validate="'required'" name="message" class="form-control" :class="{'input': true, 'is-invalid': errors.has('message') }" placeholder="ข้อความ"></textarea>
              <i v-show="errors.has('message')" class="fas fa-warning"></i>
              <span v-show="errors.has('message')" class="text-danger text-10">{{ errors.first('message') }}</span>
            </div>
            <div class="form-group">
              <button type="submit" class="btn btn-block bg-orange text-light">ส่งข้อความ</button>
            </div>
          </form>
        </div>
        <div class="col-lg-6 col-sm-12">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d15811.840891395615!2d100.5057021843906!3d7.038257246306617!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e1!3m2!1sth!2sth!4v1555052317998!5m2!1sth!2sth"
            width="100%"
            height="100%"
            frameborder="0"
            style="border:0"
            allowfullscreen
          ></iframe>
        </div>
      </div>

      <br>
      <br>
      <br>
      <br>
    </div>
    <Footer/>
  </div>
</template>
<style>
.font-contact {
  font-size: 12px;
}
</style>
<script>
import Header from "../components/Header"
import Footer from '../components/Footer'
export default {
  components: {
    Header,Footer,
  },
  data() {
    return {
      form: new Form({
        name :'',
        email:'',
        phone:'',
        message:'',
      })
    }
  },
  methods:{
    sendMessage(){
        this.$validator.validateAll().then((result) => {
        if (result) {
          this.form.post('http://pgm01.toonjob.com/2019/BannKlong/project/sendMessage')
          .then((response) => {
            this.form.reset()
            toast.fire({
              type:'success',
              title: response.data.message
            })
          })
        }
        })
      }
  },
  created() {
    this.$Progress.start();

    this.$Progress.finish();
  }
};
</script>



// WEBPACK FOOTER //
// src/frontEnd/ContactPage.vue